// extracted by mini-css-extract-plugin
export var browseMoreNav = "usecase-preview-grid-module--browseMoreNav--9203c typography-module--small--2877f";
export var grid = "usecase-preview-grid-module--grid--3369c";
export var headline = "usecase-preview-grid-module--headline--47f3e typography-module--responsiveTitle3--2bebc";
export var root = "usecase-preview-grid-module--root--128d0";